module.exports = __webpack_public_path__ + "static/media/fahrenheit.1bffb4ff.png";